var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.975,
    height: 38.975,
    viewBox: "0 0 38.975 38.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1533.331 -122.595)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1533.331 122.595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.951,3.045h-3.5V1.218a1.218,1.218,0,1,0-2.436,0V3.045H10.962V1.218a1.218,1.218,0,0,0-2.436,0V3.045h-3.5A5.03,5.03,0,0,0,0,8.069V33.951a5.03,5.03,0,0,0,5.024,5.024H33.951a5.03,5.03,0,0,0,5.024-5.024V8.069A5.03,5.03,0,0,0,33.951,3.045Zm2.588,30.906a2.588,2.588,0,0,1-2.588,2.588H5.024a2.588,2.588,0,0,1-2.588-2.588V13.778a.381.381,0,0,1,.381-.381H36.158a.381.381,0,0,1,.381.381Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    transform: "translate(1540 141)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    transform: "translate(1540 150)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    transform: "translate(1550 141)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    transform: "translate(1550 150)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    transform: "translate(1560 141)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    transform: "translate(1560 150)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3f493d742609cff73a21def6f441b9d8.svg";
export { ForwardRef as ReactComponent };